import { SitecoreFieldValidator } from '_utils/validationChecks/definitions';

export const magazinePageBannerValidators: SitecoreFieldValidator[] = [
  {
    field: 'rendering.fields.data.datasource.latestMagazine.targetItem.id',
    errorMessage: 'Magazine Page Banner component needs to point to a magazine datasource item',
    required: true,
  }
];
